import './Box.scss'
const Box = ({clas, card}) => {
    return(
        <div className={clas}>
 
        </div>
    )
}
export default Box;